<template>
    <div v-if="asyncDataStatus_ready">

    <v-row>
      <v-breadcrumbs :items="breadcrumbs" divider=">" style="padding: 12px">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :href="item.href"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-row justify="space-between">
      <v-col cols="6" md="3">
        <v-text-field
          v-if="businessUnits.length"
          placeholder="Išči..."
          append-icon="mdi-search"
          v-model="filter"
          @keydown.esc="filter=''"
        ></v-text-field>
      </v-col>
      <v-col cols="auto">
        <v-btn
          color="#0F998E"
          class="white--text"
          @click="$router.push({name: 'ClientsBusinessUnitsDevicesNew', params: { childCompanyId, businessUnitId }})"
        >
          Nova blagajna
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row v-if="businessUnits.length">
      <v-col
        cols="12" md="6" lg="4" xl="3"
        v-for="item of filteredDevices" :key="item.id"
      >
        <DeviceCard
          :device="item"
          @edit="$router.push({name: 'ClientsBusinessUnitsDevicesEdit', params: { childCompanyId, businessUnitId, deviceId: item.id}})"
          @delete="currentDevice = item; showDeleteDeviceModal = true;"
          @deleteData="currentDevice = item; showDeleteDataModal = true;"
          @deregister="currentDevice = item; showDeregisterDeviceModal = true;"
          @toggleActive="currentDevice = item; showToggleActiveModal = true;"
          @toggleFiscalization="currentDevice = item; showToggleFiscalizationModal = true;"
          @sourceFile="$router.push({name: 'ClientsBusinessUnitsDevicesSourceFile', params: { childCompanyId, businessUnitId, deviceId: item.id}})"
        />
      </v-col>
    </v-row>
    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Ni rezultatov iskanja. Za dodajanje nove blagajne uporabite gumb desno zgoraj.
        </p>
      </v-col>
    </v-row>

    <ConfirmDialog
      title="Brisanje blagajne"
      text="Ali ste prepričani, da želite izbrisati blagajno? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteDeviceModal"
      @confirmed="remove(currentDevice)"
    />
    <ConfirmDialog
      title="Brisanje podatkov"
      text="Ali ste prepričani, da želite izbrisati podatke o računih, ki se ne bodo fiskalizirali? Podatki bodo trajno izbrisani."
      okBtnText="Briši"
      v-model="showDeleteDataModal"
      @confirmed="deleteData(currentDevice)"
    />
    <ConfirmDialog
      title="Preklic registracije"
      text="Ali ste prepričani, da želite <b>preklicati registracijo</b> blagajne? Če so na blagajni neportjeni računi, jih ne bo več mogoče potrditi!"
      okBtnText="Prekliči registracijo"
      v-model="showDeregisterDeviceModal"
      @confirmed="deregisterDevice(currentDevice)"
    />
    <ConfirmDialog
      title="Spremba aktivnosti blagaje"
      :text="`Ali ste prepričani, da želite ${currentDevice && currentDevice.enabled ? '<b>deaktivirati</b>' : '<b>aktivirati</b>'} blagajno?${currentDevice && currentDevice.enabled ? ' Neaktivne naprave ne omogočajo izdaje računov!' : ''}`"
      okBtnText="V redu"
      v-model="showToggleActiveModal"
      @confirmed="toggleActive(currentDevice)"
    />
    <ConfirmDialogFiscalization
      :status="currentDevice.fiscalization"
      v-model="showToggleFiscalizationModal"
      @confirmed="toggleFiscalization"
      v-if="currentDevice"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'
import { siIncludes } from '@/utils/str'
import ConfirmDialog from '@/components/ConfirmDialog'
import ConfirmDialogFiscalization from '@/components/ConfirmDialogFiscalization'
import DeviceCard from '@/components/DeviceCard'
import { objectToArray } from '@/utils/object'

export default {
  components: {
    ConfirmDialog,
    ConfirmDialogFiscalization,
    DeviceCard
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    childCompanyId: {
      required: true,
      type: Number
    },
    businessUnitId: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      filter: '',
      showDeleteDeviceModal: false,
      showDeregisterDeviceModal: false,
      showToggleActiveModal: false,
      showToggleFiscalizationModal: false,
      showDeleteDataModal: false,
      currentDevice: null,
      breadcrumbs: [
        {
          text: 'Stranke',
          disabled: false,
          href: '/clients'
        },
        {
          text: 'Poslovne enote',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/business-units'
        },
        {
          text: 'Blagajne',
          disabled: false,
          href: '/clients/' + this.childCompanyId + '/business-units/' + this.businessUnitId + '/devices'
        }
      ]
    }
  },
  computed: {
    businessUnits () {
      return objectToArray(this.$store.state.clientsDevices.items)
    },
    filteredDevices () {
      return this.businessUnits.filter(item => siIncludes({ haystack: `${item.name}`, needle: this.filter }))
    }
  },
  methods: {
    ...mapActions('clientsDevices', ['loadItems', 'deleteItem', 'deregister', 'enable', 'disable', 'turnFiscalizationOn', 'turnFiscalizationOff']),
    remove (item) {
      this.deleteItem({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Element uspešno izbrisan.'
          }) */
        })
    },
    deleteData (item) {
      alert('data deleted')
    },
    deregisterDevice (item) {
      this.deregister({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id })
        .then(() => {
          /* this.$notify({
            type: 'success',
            text: 'Registracija blagajne je bila uspešno preklicana.'
          }) */
        })
    },
    toggleActive (item) {
      if (item.enabled) {
        this.disable({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id })
          .then(() => {
            /* this.$notify({
              type: 'success',
              text: 'Naprava je neaktivna.'
            }) */
          })
      } else {
        this.enable({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id })
          .then(() => {
            /* this.$notify({
              type: 'success',
              text: 'Naprava je aktivna.'
            }) */
          })
      }
    },
    toggleFiscalization ({ deleteData }) {
      const item = this.currentDevice
      if (item.fiscalization) {
        this.turnFiscalizationOff({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id })
          .then(() => {
            /* this.$notify({
              type: 'success',
              text: 'Davčno potrjevanje deaktivirano.'
            }) */
          })
      } else {
        this.turnFiscalizationOn({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId, deviceId: item.id, deleteData })
          .then(() => {
            /* this.$notify({
              type: 'success',
              text: 'Davčno potrjevanje aktivirano.'
            }) */
          })
      }
    }
  },
  created () {
    this.loadItems({ childCompanyId: this.childCompanyId, businessUnitId: this.businessUnitId })
      .then(items => { this.asyncDataStatus_fetched() })
  }
}
</script>
